export default "__VITE_ASSET__fb61b090__"